import { create } from "zustand"

type modalReporteState = {
  isOpen: boolean,
  setIsOpen: (open: boolean) => void
}

export const useModalReporteCompraStore = create<modalReporteState>((set) => ({
  isOpen: false,
  setIsOpen: (isOpen) => set({
    isOpen: isOpen
  })
}))